/* Copyright 2013 - 2024 Waiterio LLC */
/** @jsxImportSource @emotion/react */
import getCountryNameByCode from '@monorepool/shared/getCountryNameByCode.js'
import getLanguageNameByCode from '@monorepool/shared/getLanguageNameByCode.js'
import { useTranslation } from '@multilocale/react/index.jsx'
import locales from '@waiterio/takeaway/locales.js'

export const paths = ['/takeaway']

export const Head = () => {
  const title = 'Takeaway | Waiterio'
  const description = 'Takeaway from the best restaurants nearby'

  return (
    <>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
    </>
  )
}

const CountriesPage = props => {
  const language = 'en'
  const { t } = useTranslation(language)

  const country2languages = locales.reduce((country2languages, locale) => {
    const [languageCode, countryCode] = locale.split('-')

    country2languages[countryCode] = country2languages[countryCode] || {}

    country2languages[countryCode].countryCode = countryCode
    country2languages[countryCode].countryName =
      getCountryNameByCode(countryCode)
    country2languages[countryCode].languageCodes =
      country2languages[countryCode].languageCodes || []
    country2languages[countryCode].languageCodes.push(languageCode)

    return country2languages
  }, {})

  let countries = Object.values(country2languages).sort((a, b) =>
    a.countryName > b.countryName ? 1 : -1,
  )
  countries = countries.map(country => ({
    ...country,
    languages: country.languageCodes.map(languageCode =>
      getLanguageNameByCode(languageCode),
    ),
  }))

  return (
    <div css={{ textAlign: 'center' }}>
      <h1>{t('Takeaway')}</h1>
      <p>Select country</p>
      {countries.map(country => {
        const { countryCode, countryName, languageCodes, languages } = country

        if (languageCodes.length === 1) {
          let href = `/takeaway/${languageCodes[0]}-${countryCode}`
          return (
            <a
              key={href}
              href={href}
              css={{
                display: 'block',
                fontSize: 18,
                lineHeight: '32px',
                padding: 8,
              }}
            >
              {countryName}
            </a>
          )
        } else {
          return (
            <div key={countryCode}>
              <div
                css={{
                  display: 'block',
                  fontSize: 18,
                  lineHeight: '32px',
                  padding: 8,
                  paddingBottom: 0,
                }}
              >
                {countryName}
              </div>
              <div css={{ display: 'flex', justifyContent: 'center' }}>
                {languages.map((language, i) => {
                  let href = `/takeaway/${languageCodes[i]}-${countryCode}`
                  return (
                    <a
                      key={href}
                      href={href}
                      css={{
                        display: 'block',
                        fontSize: 18,
                        lineHeight: '32px',
                        padding: '0 8px',
                      }}
                    >
                      {language}
                    </a>
                  )
                })}
              </div>
            </div>
          )
        }
      })}
    </div>
  )
}

export default CountriesPage
